<template>
  <div class="kk-designer kk-designer__no-design-text">
    <div>
      <i18n-t keypath="processDesigner.noDesign.text" tag="p" scope="global">
        <template #selectDesign>
          <b>{{ $t("processDesigner.noDesign.selectDesign") }}</b>
        </template>
        <template #createOne>
          <a data-test-id="create-one-button" class="kk-designer__create-btn" @click="createProcessDesign">
            {{ $t("processDesigner.noDesign.createOne") }}
          </a>
          <context-menu v-if="showContextMenu" />
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<script>
import { ContextMenuIds } from "../../utils/constants";
import ContextMenu from "./ContextMenu.vue";
export default {
  components: { ContextMenu },
  props: [],
  data() {
    return {};
  },
  computed: {
    activeContextMenu() {
      return this.$store.state.activeContextMenu;
    },
    showContextMenu() {
      // dont show context menu on trash and it's immediate children
      return this.activeContextMenu.id === ContextMenuIds.Process;
    },
  },
  mounted() {},
  methods: {
    createProcessDesign(e) {
      return this.$store.dispatch("setActiveContextMenu", {
        id: ContextMenuIds.Process,
        x: e.x,
        y: e.y,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables";

.kk-designer {
  &__no-design-text {
    align-items: center !important;
    justify-content: center !important;
    border: 1px dashed @kk-color-dark;
    border-radius: 0.75rem;
    padding: 1rem;
    color: @kk-color-dark;
    font-family: "Ubuntu", sans-serif;
    text-align: center;
    font-size: 1.6rem;
    height: calc(100vh - 6rem) !important;
    margin: 1rem 0rem 1rem 7px;
  }

  &__create-btn {
    color: @kk-color-black;
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>
